export default {
    computed: {
        greeting() {
            let hours = new Date().getHours();

            if (hours < 12) {
                return 'Good morning';
            } else if (hours < 17) {
                return 'Good afternoon';
            } else {
                return 'Good evening';
            }
        }
    }
}
